import { trackBookingLogic } from './trackBookingLogic';

export const logic = [trackBookingLogic];
